import { Box, Button, Typography } from "@mui/material";
import ExternalLinkAnchor from "../../common/ExternalLinkAnchor";

import { useClientDetails } from "../context/clientDetailsContext";
import { useNavigate } from "react-router";
import routes from "../../../routes";

function ProfileAnchor({ clientId }: { clientId: string }) {
  return (
    <>
      <ExternalLinkAnchor
        url={`https://dashboard.earthly.org/${clientId}`}
        dataTestid="client-details-v3-profile-url-anchor"
        label="Go to dashboard"
      />
    </>
  );
}

function Header() {
  const navigate = useNavigate();

  const { client, updateClientDetails, replaceMainUser, clientId } =
    useClientDetails();

  if (!client.details) {
    throw Error("Client details are required");
  }
  if (!client.details.mainUser) {
    throw Error("Main user details are required");
  }
  const stripeInvoicesUrl = client.details.mainUser.stripeInvoicesUrl ?? "";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignContent: "flex-start",
        }}
      >
        <Typography align="left" variant="h4">
          {client.details.name}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignContent: "flext-start",
            paddingTop: 2,
          }}
        >
          <Box
            sx={{
              paddingRight: 2,
            }}
          >
            <ProfileAnchor clientId={clientId} />
          </Box>
          {stripeInvoicesUrl ? (
            <ExternalLinkAnchor
              url={stripeInvoicesUrl}
              dataTestid="client-details-stripe-invoices-url-anchor"
              label="Stripe Invoices"
            />
          ) : (
            <Typography variant="body1" align="left" sx={{ marginTop: "8px" }}>
              💁🏻‍♂️ Link Owner to Stripe to see invoices
            </Typography>
          )}
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            gap: 1,
          }}
        >
          <Button
            variant="contained"
            size="medium"
            onClick={() => {
              updateClientDetails.setAlert(null);
              replaceMainUser.setAlert(null);
              updateClientDetails.setEditing(true);
            }}
          >
            Edit Client
          </Button>
          <Button
            variant="outlined"
            size="medium"
            onClick={() => navigate(routes.clients.base({}))}
          >
            Back To Client List
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default Header;
